import {Outlet} from 'react-router-dom';

import JsonData from '../../data/data.json';
import {FooterScreen} from '../FooterScreen';
import {Navbar} from '../Navbar';

const LayoutComponent = () => {
  return(
    <div className={'flex flex-col min-h-screen bg-primary-950'}>
      <Navbar />
      <div className={'pt-24'}>  
        <Outlet />
      </div>
      <div className={'pt-10 bg-primary-950'}>
        <FooterScreen  data={JsonData.Footer} />
      </div>
    </div>
  );
};

export default LayoutComponent;
